import $ from "jquery";
var multiUpload = function () {
    var $thisEl = $(this);
    var $field = $thisEl.find(".multi-upload__control");
    var $fileContainer = $thisEl.find(".multi-upload__files");
    $field.off("change");
    $field.on("change", function () {
        var files = $field[0].files;
        if (!files)
            return;
        var fileValues = Object.values(files);
        var filesCount = fileValues.length;
        var fileSize = 0;
        var fileArray = fileValues.map(function (_a, index) {
            var name = _a.name, size = _a.size;
            fileSize += size;
            return ("\n        <li data-index=\"" + index + "\">\n          " + name + "\n          <button\n            type=\"button\"\n            data-index=\"" + index + "\"\n            class=\"multi-upload__delete\"\n            title=\"Smazat\"\n            aria-label=\"Smazat\"\n          >\n            &#9587;\n          </button>\n        </li>\n      ").trim();
        });
        $fileContainer.html("");
        if (filesCount > 4 || fileSize > 10485760) {
            if (filesCount > 4) {
                $fileContainer.append("<li>ERROR: Maxim\u00E1ln\u011B lze nahr\u00E1t 4 soubory!</li>");
            }
            if (fileSize > 10485760) {
                $fileContainer.append("<li>ERROR: Velikost souboru ne v\u00EDce ne\u017E 10 MB!</li>");
            }
            $field[0].value = "";
        }
        else {
            fileArray.map(function (file) { return $fileContainer.append(file); });
        }
    });
    $thisEl.off("click", ".multi-upload__delete");
    $thisEl.on("click", ".multi-upload__delete", function () {
        var files = $field[0].files;
        if (!files)
            return;
        var $button = $(this);
        var index = $button.data("index");
        var dt = new DataTransfer();
        Object.entries(files).map(function (_a) {
            var i = _a[0], file = _a[1];
            if (i != index) {
                dt.items.add(file);
            }
        });
        $field[0].files = dt.files;
        $field.trigger("change");
    });
};
export var reloadScriptMultiUpload = function () {
    return $(".multi-upload").each(multiUpload);
};
reloadScriptMultiUpload();
